import { render, staticRenderFns } from "./VersionClassificationDialog.vue?vue&type=template&id=2fc8c69e"
import script from "./VersionClassificationDialog.vue?vue&type=script&lang=js"
export * from "./VersionClassificationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports